import { amountToNumber } from '../../../util/shared/vue-global';

export const determineCssProps = (transaction) => {
  const cssProp = ['orange', 'accent-1'];
  const unpaidCssProp = ['red', 'accent-2'];
  const cscCssProp = ['purple', 'accent-1'];

  const fullAmount = amountToNumber(transaction.amount);
  const amountPaid = (transaction.paymentDetails
    || []).reduce((sum, detail) => sum + (detail.amount ? amountToNumber(detail.amount) : 0.00),
    0.00);
  const formattedAmountPaid = amountToNumber(amountPaid);

  const isPaidInFull = fullAmount === formattedAmountPaid;

  if (transaction.isVoid === true) {
    return cssProp;
  } if (transaction.dataSource && transaction.dataSource === 'eVendor' && !transaction.isVerified) {
    return cscCssProp;
  } if (((transaction.paymentDetails || []).length === 0 || !isPaidInFull)
    && !transaction.transactionNumberObject) {
    return unpaidCssProp;
  }
  return [];
};

export default {};
